import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material'
import ListModule from '../module/ListModule'
import { useOutletContext } from 'react-router-dom'
import { dateOperators, equalityOperators, multiselectOperators, textOperators } from '../../utils/constants/operators'
import { auditType } from '../../utils/constants/misc'
import { useMemo } from 'react'

function AuditDialog({ onClose, id: idProp, objectType, modelType, open, ...other }) {
  const userRight = useOutletContext()

  const handleClose = () => onClose && onClose()

  const columns = useMemo(
    () => [
      {
        name: 'datetime',
        label: 'Date/Heure',
        inputType: 'date',
        type: 'date',
        format: 'DD/MM/YYYY hh:mm:ss',
        isFilter: true,
        operators: dateOperators
      },
      {
        name: 'type',
        label: 'Type',
        isFilter: true,
        values: auditType,
        valueEditorType: 'multiselect',
        operators: [...multiselectOperators, ...equalityOperators],
        mapping: (name) => auditType.find((item) => item.name === name)?.label || name
      },
      {
        name: 'modelType',
        label: 'Modèle',
        isFilter: true,
        operators: textOperators
      },
      {
        name: 'objectType',
        label: 'Objet',
        isFilter: true,
        operators: textOperators
      },
      { name: 'modification', label: 'Modifications' },
      { name: 'createdBy', label: 'Par' }
    ],
    []
  )

  const options = useMemo(
    () => ({
      objectType: 'audits',
      accessRight: { ...userRight, is_delete: true },
      objectFilter: () => ({
        objectType,
        modelType,
        parentId: idProp
      }),
      tableStyle: { maxHeight: 350, padding: '1px' },
      paperStyle: { width: '100%' },
      isFilter: true,
      columns
    }),
    [userRight, objectType, modelType, idProp, columns]
  )

  const toolbar = useMemo(
    () => ({
      isFilter: true,
      style: { marginTop: '5px', marginBottom: '5px' },
      columns
    }),
    [columns]
  )

  return (
    <Dialog
      aria-labelledby='audit-dialog'
      maxWidth='md'
      open={open}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': {
          width: '800px',
          maxHeight: '600px',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
      {...other}
    >
      <DialogTitle id='audit-dialog-title'>Audits</DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            height: 400,
            display: 'flex'
          }}
        >
          <ListModule options={options} toolbar={toolbar} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  )
}

export default AuditDialog
